import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

/**
 * Plays the price bar's fill animation once, the first time it scrolls
 * into view, instead of showing it already filled on page load.
 *
 * @extends {Component}
 */
export class PricingValueBarComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    if (prefersReducedMotion() || !window.IntersectionObserver) {
      this.classList.add('is-visible');
      return;
    }

    this.boundHandleIntersection = this.handleIntersection.bind(this);
    this.observer = new IntersectionObserver(this.boundHandleIntersection, { threshold: 0.4 });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      this.classList.add('is-visible');
      this.observer?.disconnect();
    });
  }
}

if (!customElements.get('pricing-value-bar-component')) {
  customElements.define('pricing-value-bar-component', PricingValueBarComponent);
}
